<div class="coming-soon-container">
  <div class="content">
    <div class="logo-container">
      <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/Logo+carr%C3%A9+Site+sp%C3%A9cial+eclat+Gris.png" alt="Applisound Logo" class="rotating-logo">
    </div>
    
    <h1>PRODUCSOUNDS</h1>
    <p>{{ 'PRODUCSOUNDS.COMING_SOON' | translate }}</p>
    
    <div class="audio-player">
      <button (click)="togglePlay()" class="play-button">
        <i class="fas" [ngClass]="isPlaying ? 'fa-pause' : 'fa-play'"></i>
      </button>
      <div class="track-info">
        <span class="track-title">{{ currentTrack.title }}</span>
        <span class="track-artist">{{ currentTrack.artist }}</span>
      </div>
    </div>
  </div>
</div>